<template>
  <div>
    <h3 v-if="label" class="mb-3">
      {{ label }}
    </h3>

    <v-autocomplete
      v-model="selected"
      @change="handleSelect"
      @keyup="setSearch"
      :label="$t('announcement.label.create.selectHosts')"
      :no-data-text="$t('appointment.filters.noData')"
      :loading="isFilterLoading"
      :items="hosts"
      autocomplete="one-time-code"
      item-text="name"
      item-value="id"
      deletable-chips
      return-object
      small-chips
      clearable
      outlined
      multiple
      chips
    />
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: 'FilterAutocomplete',

  props: {
    value: {
      type: Array,
    },

    label: {
      type: String,
    },

    selectedHosts: {
      type: Array,
      default: []
    }
  },

  watch: {
    selectedHosts(hosts) {
      this.hosts = hosts
      this.selected = hosts
    }
  },

  methods: {
    ...mapMutations(['setSearchTextHosts']),
    ...mapActions(['fetchHostsBySearchText']),

    async setSearch({ target }) {
        if (this.value) {
            for (var item in this.value) {
                target.value.replace(item.name, "")
            }
        }
        this.isFilterLoading = true
        await this.fetchHostsBySearchText(target.value)
        this.hosts = this.searchTextHosts
        this.addMissingHosts()
        this.isFilterLoading = false
    },
    clearFilter() {
        this.isFilterLoading = false
        this.setSearchTextHosts([])
    },
    addMissingHosts() {
      if (this.value) {
        this.value.forEach(selectedHost => {
           if (this.hosts.filter(host => host.id == selectedHost.id).length <= 0) {
              this.hosts.push(selectedHost)
            }
        })
      }
    },
    handleSelect(value) {
      this.$emit('input', value)
    },
  },

  computed: {
    ...mapGetters(['searchTextHosts']),
  },
  data() {
    return {
      selected: [],
      params: {},
      hosts: [],
      isFilterLoading: false,
    }
  },
}
</script>
